import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import { SecondaryStyle } from "../fonts";
import SwipeableTextMobileStepper from "./MobileStepper";

import RC from "../assets/Page6RC.webp";
import LD from "../assets/Page6LD.webp";
import LCT1 from "../assets/Page6LCT1.webp";
import LCT2 from "../assets/Page6LCT2.webp";
import LCB from "../assets/Page6LCB.webp";

//@ts-ignore
import LA from "../assets/Page6LA.mp4";
//@ts-ignore
import RB from "../assets/Page6RB.mp4";

const carousel1Images = [LCT1, LCT2];

const Page6 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: {
                        xs: "45vh",
                        sm: "100%",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />

                  {/**LB */}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: { xs: "46vh", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: { xs: "45vh", sm: "100%" },
                        objectFit: "cover",
                      }}
                      src={LA}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "82.5vh", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "24.5vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper
                        images={carousel1Images}
                        autoplay={false}
                      />
                    </Box>
                    <Box
                      sx={{
                        height: { xs: "45.5vh", sm: "24.5vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                        backgroundImage: `url('${LCB}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Grid>

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.2vw",
                            md: "1.3vw",
                            lg: "1.35vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      Located in Toronto's Parkdale neighbourhood, right off
                      Queen Street West, 6 O'Hara Place offers a vibrant, social
                      lifestyle enriched by the best of urban living and
                      abundant green spaces. Just steps from corner grocers,
                      eclectic shops, and community amenities like the public
                      library, this home places you at the heart of a lively
                      community. Queen West's unique vibe, with its mix of artsy
                      boutiques, lively bars, and trendy restaurants, creates a
                      dynamic atmosphere perfect for those who love to explore.
                      With Trinity Bellwoods Park, Dufferin Grove Park, and
                      nearby green spaces, enjoy endless opportunities for
                      outdoor activities, social gatherings, and relaxing in
                      nature.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    {/* RD */} {/* RA */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: { xs: "1vh solid #fff", sm: "none" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                        },

                        height: { xs: "45vh", sm: "100%" },
                        maxHeight: "50vh",
                      }}
                    >
                      <CardMedia
                        component={"iframe"}
                        allowFullScreen
                        loading="eager"
                        title="Embedded Street View"
                        referrerPolicy="no-referrer-when-downgrade"
                        sx={{
                          border: 0,
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: { xs: "16px", sm: "0vh" },
                        }}
                        src="https://www.google.com/maps/embed?pb=!4v1725353515734!6m8!1m7!1svrwlGUQ5Ke2qdw-GQNbxyw!2m2!1d43.64113882876241!2d-79.43420457216156!3f68.4!4f-0.9399999999999977!5f1.036612209036868"
                      />
                    </Grid>
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fffe",
                        },
                        borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        height: {
                          xs: "46vh",
                          sm: "50vh",
                        },
                        backgroundImage: `url('${RC}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    {/* RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },

                        borderBottom: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },

                        height: {
                          xs: "46.5vh",
                          sm: "50vh",
                        },
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: {
                            xs: "45vh",
                            sm: "100%",
                          },
                          maxHeight: "50vh",

                          objectFit: "cover",
                        }}
                        src={RB}
                        playsInline
                        autoPlay
                        muted
                        loop
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page6;
